import { render, staticRenderFns } from "./appoint-file-upload.vue?vue&type=template&id=02ce9e2c&scoped=true&"
import script from "./appoint-file-upload.vue?vue&type=script&lang=js&"
export * from "./appoint-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./appoint-file-upload.vue?vue&type=style&index=0&id=02ce9e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce9e2c",
  null
  
)

export default component.exports